import request from '@/http/request'

/**
 * 收藏/取消收藏切换
 * @param {Number} productId 产品ID
 * @returns {Promise}
 */
export function toggleFavorite(productId) {
    return request({
        url: '/system/favorite/toggle',
        method: 'post',
        params: { productId }
    })
}

/**
 * 获取当前用户所有收藏产品ID集合
 * @returns {Promise}
 */
export function getFavIdList() {
    return request({
        url: '/system/favorite/ids',
        method: 'get'
    })
}

/**
 * 分页获取我的收藏列表
 * @param {Number} pageNum 页码
 * @param {Number} pageSize 每页条数
 * @returns {Promise}
 */
export function getFavoriteList(pageNum, pageSize) {
    return request({
        url: '/system/favorite/list',
        method: 'get',
        params: { pageNum, pageSize }
    })
}

/**
 * 获取收藏产品完整详情（含颜色图片、功率、光束角等参数）
 * @param {Number} pageNum 页码
 * @param {Number} pageSize 每页条数
 * @returns {Promise}
 */
export function getFavoriteProducts(pageNum, pageSize) {
    return request({
        url: '/system/favorite/products',
        method: 'get',
        params: { pageNum, pageSize }
    })
}

/**
 * 公开接口：根据产品ID批量查询产品详情（供匿名用户使用）
 * @param {Array} idArr 产品ID数组
 * @returns {Promise}
 */
export function getProductDetailsByIds(idArr) {
    return request({
        url: '/system/favorite/product-details',
        method: 'get',
        params: { ids: idArr.join(',') }
    })
}

/**
 * 批量删除收藏
 * @param {Array} favIdArr 收藏ID数组
 * @returns {Promise}
 */
export function batchDelFav(favIdArr) {
    return request({
        url: '/system/favorite/batch',
        method: 'post',
        data: favIdArr
    })
}
